import { Component } from '@angular/core';
import { UserService } from '@services/user.context/user.context.service';
import { TranslateService } from '@ngx-translate/core';
import { HttpClient } from '@angular/common/http';
import { ProfileAlertsService } from '@services/admin-profile/profile-alerts.service';
import { StaleBuildReloadService } from '@services/stale-build/stale-build-reload.service';
import { of } from 'rxjs';
import { map, catchError } from 'rxjs/operators';

@Component({
  standalone: false,
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
})
export class AppComponent {
  title = 'EviNature';

  userCheck: any;

  constructor(
    private userService: UserService,
    public translate: TranslateService,
    private profileAlertsService: ProfileAlertsService,
    private http: HttpClient,
    staleBuildReload: StaleBuildReloadService
  ) {
    this.userCheck = userService.getUser();

    // A tab left open across a deploy can't load the new build's lazy sections;
    // reload into the requested page instead of leaving the click dead.
    staleBuildReload.start();

    // Register flagged orders alert provider
    this.profileAlertsService.registerProvider((_profile) => {
      const currentUser = this.userService.getUser();
      if (!currentUser) return of([]);

      return this.http.post<any>('/api/flagged-orders/search/by-crit', {
        filter: {
          status: { $in: ['pending', 'in-review'] },
          assignedTo: currentUser._id
        }
      }).pipe(
        map((res: any) => {
          const rows = res?.rows || [];
          return rows.map((item: any) => ({
            id: item._id,
            profile: 'all',
            severity: 'warning',
            icon: item.type === 'user' ? 'bi bi-person-fill text-info' : 'bi bi-cart-fill text-warning',
            title: item.type === 'user' ? `Flagged User: ${item.customerName || item.email}` : `Flagged Order: ${item.shopifyOrderNumber || item.email}`,
            message: item.notes || item.reason || 'Assigned flag requires review.',
            route: `/dashboard/patients/flagged-orders/${item._id}`
          }));
        }),
        catchError(() => of([]))
      );
    });
  }
}
